import { PortalSandboxPage } from "../../../components/gov/PortalSandboxPage";
import { MUDAD_CONFIG } from "../../../components/gov/portalConfigs";

export function MudadPortalPage() {
  return <PortalSandboxPage config={MUDAD_CONFIG} />;
}

export default MudadPortalPage;
